import type { NotificationType } from "@praesto/shared-types";

export type NotificationArea = "shifts" | "monitoring" | "procedure";

/** The types configurable in the admin/personal grids, grouped by module.
 *  Only types something actually sends belong here: a row in this grid is a
 *  promise that the notification can arrive. Each one has a producer in
 *  `functions/src/triggers/`.
 *  auth.mfa_code and system.alert are intentionally excluded (out-of-band / system).
 *  Removed because nothing emits them (C-17): shift.cancelled (a published shift
 *  cannot be deleted), shift.starting_soon, availability.reminder and
 *  checklist.reminder (each would need a scheduled job). They stay in
 *  `NotificationType` so rules a tenant saved for them still validate. */
export const CONFIGURABLE_NOTIFICATION_TYPES: ReadonlyArray<{
  area: NotificationArea;
  type: NotificationType;
}> = [
  { area: "shifts", type: "shift.assigned" },
  { area: "shifts", type: "shift.changed" },
  { area: "shifts", type: "shift.swapped" },
  { area: "shifts", type: "schedule.published" },
  { area: "shifts", type: "leave.requested" },
  { area: "shifts", type: "leave.decided" },
  { area: "monitoring", type: "report.created" },
  { area: "monitoring", type: "report.resolved" },
  { area: "monitoring", type: "monitoring.comment.mentioned" },
  { area: "procedure", type: "sop.published" },
  { area: "procedure", type: "sop.updated" },
];

/** Types that used to be in the grid and were taken out because nothing
 *  sends them. Kept as a list so tests can assert they stay out. */
export const UNSENT_NOTIFICATION_TYPES: ReadonlyArray<NotificationType> = [
  "shift.cancelled",
  "shift.starting_soon",
  "availability.reminder",
  "checklist.reminder",
];
